/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_1_DescInputs */

const en_mk_parts_1_desc = /** @type {(inputs: Mk_Parts_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List, board or table; statuses, priorities, labels, staged sub-issues and dependencies. Quick for non-technical people, tidy enough to answer for.`)
};

const id_mk_parts_1_desc = /** @type {(inputs: Mk_Parts_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar, papan, atau tabel; status, prioritas, label, sub-issue bertahap, dan dependensi. Cepat dipakai orang non-teknis, cukup rapi untuk dipertanggungjawabkan.`)
};

/**
* | output |
* | --- |
* | "List, board or table; statuses, priorities, labels, staged sub-issues and dependencies. Quick for non-technical people, tidy enough to answer for." |
*
* @param {Mk_Parts_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_1_desc = /** @type {((inputs?: Mk_Parts_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_1_desc(inputs)
	return en_mk_parts_1_desc(inputs)
});